module.exports = __webpack_public_path__ + "operace-nosu_10_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_10_after.jpg
// module id = 1127
// module chunks = 0